export default class GoUp {
    constructor() {
        this.$el = $('.go-up');
        this.observe();

        this.$el.on('click', this.scrollUp.bind(this));
    }

    observe() {
        const ratio = 0.95;

        const observer = new IntersectionObserver((entries) => {
            if (entries[0].intersectionRatio < ratio) {
                this.show();
            } else {
                this.hide();
            }
        }, { threshold: [ratio] });

        const catalogTitle = document.querySelector('.catalog__title');

        if (catalogTitle) {
            observer.observe(catalogTitle);
        }

        const pageTitle = document.querySelector('.page-title');

        if (pageTitle) {
            observer.observe(pageTitle);
        }
    }

    show() {
        this.$el.removeClass('go-up--hidden');
    }

    hide() {
        this.$el.addClass('go-up--hidden');
    }

    scrollUp() {
        $('html, body').animate({ scrollTop: 0 }, 300);
    }
}